import type { OrderProductType } from "@/api/order";

export type ActionBtn = {
  label: string;
  type: "secondary" | "primary" | "review" | "reorder" | "service";
  action?:
    | "pay"
    | "cancel"
    | "review"
    | "invoice"
    | "afterSale"
    | "cancelRefund";
};

export interface UseOrderActionsOptions {
  productType: OrderProductType;
  mainStatusStep: number;
  mainStatus: string;
  hasRefund?: number;
  refundStatus?: number;
  hasComment?: number;
  hasInvoice?: number;
}

export function useOrderActions(options: UseOrderActionsOptions) {
  const {
    productType,
    mainStatusStep,
    mainStatus,
    hasRefund,
    refundStatus,
    hasComment,
    hasInvoice,
  } = options;
  console.log("aaaaaaaaaaaaaaaaaa");
  console.log(options);

  const getBtns = (): ActionBtn[] => {
    // 已完成状态（hotel: step=3；tour/car: step=4）
    const isCompletedByStep =
      productType === "tour" || productType === "car"
        ? mainStatusStep === 5
        : mainStatusStep === 3;
    const isCompleted = isCompletedByStep || mainStatus === "已完成";

    // 售后中
    if (hasRefund === 1 && refundStatus !== 30) {
      if (refundStatus === 0) {
        return [
          { label: "取消售后", type: "secondary", action: "cancelRefund" },
        ]; // 待处理
      }
      if (refundStatus === 10) {
        const arr: ActionBtn[] = [{ label: "再次预订", type: "reorder" }];
        if (!hasInvoice && isCompleted) {
          arr.push({ label: "申请开票", type: "primary", action: "invoice" });
        }
        if (!hasComment && isCompleted) {
          arr.push({ label: "去评价", type: "review", action: "review" });
        }
        return arr;
      }
      // 已驳回/已退款/已取消 → 无售后操作
      return [{ label: "再次预订", type: "reorder" }];
    }

    if (mainStatus.includes("待支付")) {
      return [
        { label: "取消订单", type: "secondary", action: "cancel" },
        { label: "支付订单", type: "primary", action: "pay" },
      ];
    }
    // 已取消 / 已退款（无在途售后单时列表仍可能展示为售后中）
    if (mainStatus === "已取消" || mainStatus === "售后中") {
      return [{ label: "再次预订", type: "reorder" }];
    }

    // 已完成 / 待评价（达人订单 status=40 显示"待评价"）→ 可评价
    if (isCompleted || mainStatus === "待评价") {
      let arr: ActionBtn[] = [];
      // 去评价按钮：未评论才显示
      if (hasComment !== 1) {
        arr.push({ label: "去评价", type: "review", action: "review" });
      }

      // ★ 售后与开票互斥：任一已操作则两者都不显示
      const hasAfterSaleOrInvoice = hasRefund === 1 || hasInvoice === 1;

      if (!hasAfterSaleOrInvoice) {
        // 都没操作过 → 同时显示（选其一后另一消失）
        if (mainStatus !== "待评价") {
          arr.push({ label: "申请开票", type: "primary", action: "invoice" });
        }
        if (isCompleted) {
          arr.push({ label: "售后服务", type: "service", action: "afterSale" });
        }
      } else {
        // 已操作过售后或开票 → 只显示"再次预订"
        arr.push({ label: "再次预订", type: "reorder" });
      }

      // 待评价状态无其他操作时，至少不返回空数组
      if (arr.length === 0 && mainStatus === "待评价") {
        return []; // 已评价完成，无按钮
      }
      return arr.length > 0 ? arr : [{ label: "再次预订", type: "reorder" }];
    }

    if (mainStatusStep === 5 || mainStatusStep === 6)
      return [{ label: "再次预订", type: "reorder" }];
    return [{ label: "申请售后", type: "secondary", action: "afterSale" }];
  };

  return { getBtns };
}

/** 按钮变体样式 */
export const BTN_STYLES: Record<
  ActionBtn["type"],
  { bg: string; color: string }
> = {
  primary: { bg: "#FF6B35", color: "#fff" },
  secondary: { bg: "#F4F5F9", color: "#6B7280" },
  review: { bg: "#E0F2FE", color: "#0369A1" },
  reorder: { bg: "#ECFDF8", color: "#059669" },
  service: { bg: "#F3E8FF", color: "#7C3AED" },
};
